import { render, staticRenderFns } from "./priority_input.vue?vue&type=template&id=43b28843&"
import script from "./priority_input.vue?vue&type=script&lang=js&"
export * from "./priority_input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports